<template>
  <div class="qst-card">
    <div class="qst-question">{{ data.title }}</div>
    <div v-if="data.type === 'text' || data.type === 'email'">
      <input
        type="text"
        :placeholder="data.placeholder"
        class="qst-control"
        v-model="controlValue"
        @change="onChangeValue"
        @blur="onBlurControl"
        @input="onInputControl"
      >
      <span v-if="errorMessage" style="color:red; font-weight: 500;">{{ errorMessage }}</span>
    </div>
    <div v-if="data.type === 'textarea'">
      <textarea
        v-model="controlValue"
        :placeholder="data.placeholder"
        rows="4"
        class="qst-control"
        @change="onChangeValue"
      ></textarea>
    </div>
    <div v-if="data.type === 'select'">
      <select v-model="controlValue" class="qst-control" @change="onChangeValue">
        <option value="">Selecciona una opción</option>
        <option v-for="opt in data.options" :key="opt.value" :value="opt.value">
          {{ opt.label }}
        </option>
      </select>
    </div>
    <div v-if="data.type === 'scale'">
      <f7-row>
        <f7-col>

        </f7-col>
      </f7-row>
      <f7-list simple-list outline-ios strong-ios>
        <f7-list-item>
          <div style="width: 100%; margin: 0 16px">
            <f7-range :min="minPrice" :max="maxPrice" :step="2500" :value="[priceMin, priceMax]" :label="true"
              :dual="true" color="#0A243F" @range:change="onPriceChange" />
          </div>
        </f7-list-item>
      </f7-list>
      <f7-row>
        <f7-col v-if="!esMovil" ></f7-col>
        <f7-col>
          <f7-list class="m-t-0" no-hairlines>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Mínimo</div>
                  <div class="item-input-wrap">
                    <input type="text" placeholder="" :value="priceMin" />
                  </div>
                </div>
              </div>
            </li>
          </f7-list>

        </f7-col>
        <f7-col>
          <f7-list class="m-t-0" no-hairlines>
            <li>
              <div class="item-content item-input">
                <div class="item-inner">
                  <div class="item-title item-label">Máximo</div>
                  <div class="item-input-wrap">
                    <input type="text" placeholder="" :value="`${priceMax} ${priceMax == maxPrice ? ' o Más' : ''}`" />
                  </div>
                </div>
              </div>
            </li>
          </f7-list>
        </f7-col>
        <f7-col v-if="!esMovil"></f7-col>
      </f7-row>
    </div>
    <div v-if="data.type === 'images'">
      <image-uploader @change="onChangeImage" @upload="onUploadImage"></image-uploader>
    </div>
    <div v-if="data.type === 'date'">
      <input type="date" class="qst-control" style="width: fit-content !important;" @change="onChangeValue" v-model="controlValue" >
    </div>
    <optional-question style="margin-top: 15px;" v-for="optqst in data.optional_questions" :key="optqst.id" :data="optqst" v-show="comprobar(optqst.opcion_select)" >
    </optional-question>
  </div>
</template>

<script>
/* eslint-disable */
import ImageUploader from './image-uploader.vue'
import OptionalQuestion from './optional-question.vue'
import { EventBus } from '../../../utils/eventBus'

export default {
  components:{ ImageUploader, OptionalQuestion },
  name: "Question",
  props: {
    data: Object
  },
  data() {
    return {
      controlValue: '',
      minPrice: 25000,
      maxPrice: 200000,
      priceMin: 25000,
      priceMax: 200000,
      esMovil: window.innerWidth < 576,
      errorMessage: ''
    }
  },
  mounted() {
    this.minPrice = this.data.min
    this.maxPrice = this.data.max
    this.priceMin = this.data.min
    this.priceMax = this.data.max
    window.addEventListener('resize', this.detectarDispositivo);
  },
  methods: {
    onPriceChange(values) {
      this.priceMin = values[0]
      this.priceMax = values[1]
      EventBus.$emit('update-answer', { id:this.data.id, value:`${this.priceMin},${this.priceMax}` })
    },
    comprobar(valores){
      return valores.includes(this.controlValue)
    },
    onChangeValue(event){
      EventBus.$emit('update-answer', { id:this.data.id, value:this.controlValue })
    },
    onBlurControl(event){

      
      if(!this.data.pattern)
      return
      
      let pattern = new RegExp(this.data.pattern)
      let result = pattern.test(this.controlValue)
      
      if(!result){
        // if(typeof event.target.reportValidity === 'function'){
        //   event.target.setCustomValidity( this.data.notValidMessage)
        //   event.target.reportValidity()
        // }
        // else{
          if(this.controlValue != ''){
            this.errorMessage = this.data.notValidMessage
          }
        // }
      }
    },
    onInputControl(event){
      // if(typeof event.target.reportValidity === 'function'){
      //   event.target.setCustomValidity("")
      // }else{
        this.errorMessage = ''
      // }
    },
    onChangeImage(imgVal){
      let images = imgVal.map(imgs => {return {name:imgs.name,  data:imgs.data}})
      EventBus.$emit('update-answer', { id:this.data.id, value:images })
    },
    onUploadImage(data){
      EventBus.$emit('upload-image', data)
    },
    detectarDispositivo() {
      this.esMovil = window.innerWidth < 576;
    }
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.detectarDispositivo);
  }
}
</script>

<style>
.qst-card {
  border-width: 1px;
  border-style: solid;
  border-radius: 5px;
  border-color: #c4c4c4;
  text-align: left;
  padding: 15px;
  margin-bottom: 15px;
}

.qst-question {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 15px;
}

.qst-control {
  box-sizing: border-box !important;
  width: 100% !important;
  background-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  border-color: #c4c4c4 !important;
  border-radius: 5px !important;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
  font-size: 14px !important;
  color: #0A243F !important;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-duration: 150ms !important;
}

.qst-control::placeholder {
  color: #A8A8A8 !important;
}

.qst-control:focus {
  outline: none;
  border-color: #1d2244 !important;
}
</style>